import { Colors } from './colors';

export type ShadowTokenName =
  | 'v1_l1'
  | 'v1_l2'
  | 'v1_l3'
  | 'v1_l4'
  | 'v1_l5'
  | 'v2_l1'
  | 'v2_l2'
  | 'v2_l3'
  | 'v2_l4'
  | 'v2_l5';

export type ShadowPart = {
  x: number;
  y: number;
  blur: number;
  spread: number;
  color: string; // rgba()
  inset?: boolean;
};

const toCss = (parts: ShadowPart[]): string =>
  parts
    .map((p) => {
      const inset = p.inset ? 'inset ' : '';
      return `${inset}${p.x}px ${p.y}px ${p.blur}px ${p.spread}px ${p.color}`;
    })
    .join(', ');

const make = (parts: ShadowPart[]): string => toCss(parts);

const shadowTokens: Record<ShadowTokenName, string> = {
  // V1
  v1_l1: make([{ x: 0, y: 0, blur: 1, spread: 1, color: Colors.grayOpacity05 }]),
  v1_l2: make([{ x: 0, y: 3, blur: 0, spread: 0, color: Colors.grayOpacity02 }]),
  v1_l3: make([
    { x: 0, y: 2, blur: 6, spread: 0, color: Colors.grayOpacity04 },
    { x: 0, y: 4, blur: 12, spread: 0, color: Colors.grayOpacity04 },
  ]),
  v1_l4: make([
    { x: 0, y: 4, blur: 4, spread: 0, color: Colors.grayOpacity04 },
    { x: 0, y: 6, blur: 16, spread: 0, color: Colors.grayOpacity07 },
  ]),
  v1_l5: make([
    { x: 0, y: 8, blur: 8, spread: 0, color: Colors.grayOpacity04 },
    { x: 0, y: 12, blur: 32, spread: 0, color: Colors.grayOpacity12 },
  ]),

  // V2
  v2_l1: make([
    { x: 0, y: 0, blur: 0, spread: 0.5, color: Colors.grayOpacity22 },
    { x: 0, y: 0, blur: 1, spread: 1, color: Colors.grayOpacity05 },
  ]),
  v2_l2: make([
    { x: 0, y: 0, blur: 0, spread: 0.5, color: Colors.grayOpacity22 },
    { x: 0, y: 3, blur: 0, spread: 0, color: Colors.grayOpacity02 },
  ]),
  v2_l3: make([
    { x: 0, y: 0, blur: 0, spread: 0.5, color: Colors.grayOpacity22 },
    { x: 0, y: 2, blur: 6, spread: 0, color: Colors.grayOpacity04 },
    { x: 0, y: 4, blur: 12, spread: 0, color: Colors.grayOpacity04 },
  ]),
  v2_l4: make([
    { x: 0, y: 0, blur: 0, spread: 0.5, color: Colors.grayOpacity22 },
    { x: 0, y: 4, blur: 8, spread: 0, color: Colors.grayOpacity04 },
    { x: 0, y: 6, blur: 16, spread: 0, color: Colors.grayOpacity07 },
  ]),
  v2_l5: make([
    { x: 0, y: 0, blur: 0, spread: 0.5, color: Colors.grayOpacity22 },
    { x: 0, y: 8, blur: 8, spread: 0, color: Colors.grayOpacity04 },
    { x: 0, y: 12, blur: 32, spread: 0, color: Colors.grayOpacity12 },
  ]),
};

export const Shadows: Record<ShadowTokenName, string> = {
  v1_l1: shadowTokens.v1_l1,
  v1_l2: shadowTokens.v1_l2,
  v1_l3: shadowTokens.v1_l3,
  v1_l4: shadowTokens.v1_l4,
  v1_l5: shadowTokens.v1_l5,
  v2_l1: shadowTokens.v2_l1,
  v2_l2: shadowTokens.v2_l2,
  v2_l3: shadowTokens.v2_l3,
  v2_l4: shadowTokens.v2_l4,
  v2_l5: shadowTokens.v2_l5,
};
